var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16.0001C0 24.8365 7.16343 32 16 32C24.8365 32 32 24.8365 32 16.0001C32 7.16349 24.8365 0 16 0C7.16343 0 0 7.16349 0 16.0001Z",
    fill: "#FC5027"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 18.2492C14.7664 18.2492 13.7505 17.2515 13.7505 16.0179C13.7505 14.7846 14.7482 13.7867 15.9999 13.7867C17.2335 13.7867 18.2494 14.7844 18.2494 16.0179C18.2312 17.2336 17.2335 18.2492 15.9999 18.2492ZM15.9999 12.6622C14.1497 12.6622 12.6621 14.1678 12.6621 16C12.6621 17.8503 14.1679 19.3378 15.9999 19.3378C17.8503 19.3378 19.3378 17.8322 19.3378 16C19.3378 14.1678 17.8322 12.6622 15.9999 12.6622Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 20.4805C13.5327 20.4805 11.5192 18.467 11.5192 15.9998C11.5192 13.5328 13.5327 11.5192 15.9999 11.5192C18.467 11.5192 20.4805 13.5328 20.4805 15.9998C20.4623 18.467 18.467 20.4805 15.9999 20.4805ZM15.9999 10.5398C12.9885 10.5398 10.5215 12.9888 10.5215 16C10.5215 19.0113 12.9703 21.4602 15.9999 21.4602C19.0112 21.4602 21.46 19.0113 21.46 16C21.46 12.9888 19.0112 10.5398 15.9999 10.5398Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 22.603C12.3537 22.603 9.39681 19.6461 9.39681 15.9999C9.39681 12.3537 12.3537 9.39672 15.9999 9.39672C19.6463 9.39672 22.6032 12.3537 22.6032 15.9999C22.6032 19.6461 19.6281 22.603 15.9999 22.603ZM28.7528 15.6553C26.1223 11.1202 21.2245 8.29034 15.9817 8.29034C10.7572 8.27219 5.85937 11.1021 3.22906 15.6553C3.10203 15.8731 3.10203 16.1453 3.22906 16.3628C5.85937 20.898 10.7572 23.7279 15.9999 23.7279C21.2426 23.7279 26.1223 20.898 28.771 16.3628C28.8799 16.1453 28.8799 15.8729 28.7528 15.6553Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logoIcon.9e07bf46b8ecd207cef5602748e50841.svg";
export { ForwardRef as ReactComponent };